import {states} from './../constants/receipt-constants';

export class ReceiptMemento {
    constructor(
        uuid,
        consignment,
        receipt,
        user,
        status,
        date,
        text
    ) {
        this.uuid = uuid;
        this.consignment = consignment;
        this.receipt = receipt;
        this.user = user;
        this.status = status;
        this.date = date;
        this.text = text;
    }

    getStatusName() {
        let status = states.find(status => (status.key === this.status));
        return !!status ? status.value : null;
    }
}